import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { DivergenceDemandsState } from './DivergenceDemandsTypes'

const selectFeature = (state: State) => state.divergenceDemands

export const selectDivergence = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergence || [],
)

export const selectDivergenceFilters = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergenceFilters || {},
)

export const selectDivergenceFilterOptions = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergenceFilterOptions,
)

export const selectActiveDivergenceId = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.activeDivergenceId,
)

export const selectActiveDivergence = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => {
    const activeDivergenceId = state?.activeDivergenceId
    if (!activeDivergenceId) return null
    return state?.divergence?.find((d) => d.id === activeDivergenceId) || null
  },
)

export const selectDivergenceActiveAddress = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergenceActiveAddress,
)

export const selectDivergenceActiveProduct = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergenceActiveProduct,
)

export const selectDivergenceActiveProductDesc = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.divergenceActiveProductDesc,
)

export const selectProductResolutionData = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.productResolutionData,
)

export const selectActiveDivergenceItemId = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.activeDivergenceItemId,
)

export const selectCurrentUser = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.user,
)

export const selectPagination = createSelector(
  selectFeature,
  (state: DivergenceDemandsState) => state?.pagination,
)

export default selectFeature
